<div class="dds-modal-overlay" (click)="close()"></div>

<div
  ddsResize
  [ngClass]="{
    'dds-modal_lg': size === 'lg',
    'dds-modal_inverse': isInverse
  }"
  class="dds-modal"
>
  <div class="dds-modal__header">
    <span class="dds-modal__title">Reset submission status</span>
    <dds-button
      size="sm"
      icon="dds-icon_close"
      kind="silent"
      theme="dark"
      ariaLabel="Close modal"
      class="dds-modal__close"
      [isInverse]="isInverse"
      (clicked)="close()"
    ></dds-button>
  </div>

  <div class="dds-modal__body">
    <div class="body-section">
      <div class="comment margin-top-xs">
        <span class="eclipse-small-header-grey"
          >Reason for resetting status</span
        >
        <dds-select
          [placeholder]="selectOptions.placeholder ?? ''"
          [list]="actionDropdownList"
          [(ngModel)]="selectedReason"
          (valueChanged)="handleDropDownSelected($event)"
          [ariaLabel]="'SelectOptions'"
          [size]="selectOptions.size ?? ''"
        ></dds-select>
      </div>
      <div
        *ngIf="showReasonTextBox"
        class="comment margin-bottom-l margin-top-xs"
      >
        <span class="eclipse-small-header-grey">Reason</span>
        <dds-textarea
          [(ngModel)]="otherReasonDescription"
          [placeholder]="textareaOptions.placeholder ?? ''"
          [maxLength]="textareaOptions.maxLength ?? 0"
          [maxLengthPosition]="textareaOptions.maxLengthPosition ?? ''"
          [minHeight]="textareaOptions.minHeight ?? 0"
          [size]="textareaOptions.size ?? ''"
          [ariaLabel]="'Additional details'"
        >
        </dds-textarea>
      </div>
    </div>
  </div>

  <div class="dds-modal__footer">
    <div class="dds-modal__footer-content dds-modal__footer-content_left">
      <dds-button
        class="dds-modal__footer-item"
        (clicked)="saveSubmissionHistory()"
        [disabled]="!formValid()"
        (keyboardClicked)="saveSubmissionHistory()"
        [ariaLabel]="'Additional close'"
        >Reset status</dds-button
      >
      <dds-button
        class="dds-modal__footer-item"
        kind="secondaryLoud"
        [isInverse]="isInverse"
        (clicked)="close()"
        (keyboardClicked)="close()"
        [ariaLabel]="'Cancel'"
        >Cancel</dds-button
      >
    </div>
  </div>
</div>
